"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Icon = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customIcons = _interopRequireDefault(require("../../../../utils/customIcons"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

require("../../../../styles/styles.scss");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* istanbul ignore next */
var MuiIcon = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('@material-ui/core/Icon'));
  });
});
/* istanbul ignore next */

var BBBSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/BBBSvg/BBBSvg'));
  });
});
/* istanbul ignore next */

var FacebookSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/FacebookSvg/FacebookSvg'));
  });
});
/* istanbul ignore next */

var GoogleSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/GoogleSvg/GoogleSvg'));
  });
});
/* istanbul ignore next */

var LinkedinSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/LinkedinSvg/LinkedinSvg'));
  });
});
/* istanbul ignore next */

var YouTubeSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/YouTubeSvg/YouTubeSvg'));
  });
});
/* istanbul ignore next */

var InstagramSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/InstagramSvg/InstagramSvg'));
  });
});
/* istanbul ignore next */

var TwitterSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/TwitterSvg/TwitterSvg'));
  });
});
/* istanbul ignore next */

var YelpSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/YelpSvg/YelpSvg'));
  });
});
/* istanbul ignore next */

var GithubSvg = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/GithubSvg/GithubSvg'));
  });
}); // import icons to use for custom icons passed down to app;

var Icon = function Icon(_ref) {
  var color = _ref.color,
      fontSize = _ref.fontSize,
      iconName = _ref.iconName,
      rootClass = _ref.rootClass,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      style = _ref.style;

  var Sus = function Sus(props) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, /*#__PURE__*/_react.default.createElement(props.Comp, (0, _extends2.default)({}, props, {
      "data-blok-c": dataBlokC,
      "data-blok-uid": dataBlokUid
    })));
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, _objectSpread({}, style));

  var customIcon = _customIcons.default.find(function (icon) {
    return icon.iconName === iconName;
  });

  if (customIcon) {
    var Custom = customIcon.Component;
    return /*#__PURE__*/_react.default.createElement(Custom, (0, _extends2.default)({
      className: "".concat(styles.root, " ").concat(storyblokClass),
      color: color,
      fontSize: fontSize,
      "data-blok-c": dataBlokC,
      "data-blok-uid": dataBlokUid
    }, customIcon.props));
  }

  switch (iconName) {
    case 'facebook':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: FacebookSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    case 'bbb':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: BBBSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    case 'linkedin':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: LinkedinSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    case 'google':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: GoogleSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    case 'youtube':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: YouTubeSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    case 'instagram':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: InstagramSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    case 'twitter':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: TwitterSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    case 'yelp':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: YelpSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    case 'github':
      return /*#__PURE__*/_react.default.createElement(Sus, {
        Comp: GithubSvg,
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass)
      });

    default:
      return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
        fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
      }, /*#__PURE__*/_react.default.createElement(MuiIcon, {
        color: color,
        fontSize: fontSize,
        className: "".concat(styles.root, " ").concat(storyblokClass),
        "data-blok-c": dataBlokC,
        "data-blok-uid": dataBlokUid
      }, iconName));
  }
};

exports.Icon = Icon;
var _default = Icon;
exports.default = _default;
Icon.propTypes = {
  /** any icon from https://material.io/resources/icons/?style=baseline */
  iconName: _propTypes.default.string.isRequired,

  /**
   * mui prop: 'inherit', 'primary', 'secondary', 'action', 'error', 'disabled'
   * The color of the component. It supports those theme colors that make sense for this component.
   * */
  color: function color(props, propName, componentName) {
    var validProp = ['inherit', 'primary', 'secondary', 'action', 'error', 'disabled'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop: 'default', 'small', 'inherit', 'large'
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * */
  fontSize: function fontSize(props, propName, componentName) {
    var validProp = ['default', 'small', 'inherit', 'large'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * storyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
Icon.defaultProps = {
  rootClass: [],
  color: 'secondary',
  fontSize: 'default',
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};